import React from 'react'
import { Button, Icon, Breadcrumb } from 'antd'
import { useTranslation } from 'react-i18next'
import AdsSectionHeaderHolder from '../styles/adsSectionHeaderStyle'
import BreadcrumbEllipsis from './BreadcrumbEllipsis'
import { collapsePath } from '../utils/folderTree'
import { translateTagName } from '../../campaignManager/hooks/contentManager/useLibraryContents'

// The title is a breadcrumb: "Mis anuncios" (root) › folder › subfolder.
// The root and ancestors are clickable; the current folder is shown in bold.
// A path deeper than 3 folders is collapsed to first › … › last, with the
// hidden middle folders reachable through a popover on the ellipsis.
const AdsSectionHeader = ({ path = [], onNavigate, onUploadAd, onCreateFolder, uploading = false }) => {
  const { t } = useTranslation()
  const atRoot = path.length === 0
  const currentId = path.length ? path[path.length - 1].id : null

  return (
    <AdsSectionHeaderHolder>
      <Breadcrumb className="ads-breadcrumb" separator=">">
        <Breadcrumb.Item
          className={`bc-root ${atRoot ? 'bc-current' : 'bc-link'}`}
          onClick={atRoot ? undefined : () => onNavigate && onNavigate(null)}
        >
          {t('My ads')}
        </Breadcrumb.Item>
        {collapsePath(path).map((item) => {
          if (item.ellipsis) {
            return (
              <Breadcrumb.Item key="ellipsis" className="bc-folder bc-ellipsis">
                <BreadcrumbEllipsis hidden={item.hidden} onNavigate={onNavigate} />
              </Breadcrumb.Item>
            )
          }
          const folder = item.folder
          const isCurrent = folder.id === currentId
          return (
            <Breadcrumb.Item
              key={folder.id}
              className={`bc-folder ${isCurrent ? 'bc-current' : 'bc-link'}`}
              onClick={isCurrent ? undefined : () => onNavigate && onNavigate(folder)}
            >
              {translateTagName(folder.name, t)}
            </Breadcrumb.Item>
          )
        })}
      </Breadcrumb>

      {/* On tablet and below the labels are hidden (.btn-label), leaving icons
          only; `title` keeps the action discoverable on hover. */}
      <div className="actions">
        <Button onClick={onUploadAd} loading={uploading} title={t('Upload ad')}>
          <Icon type="upload" />
          <span className="btn-label">{t('Upload ad')}</span>
        </Button>
        {/* TODO API: folder creation has no backend endpoint yet — the modal
            flow is enabled but the dispatch is commented out (see AdLibraryModals). */}
        <Button type="primary" onClick={onCreateFolder} title={t('New folder')}>
          <Icon type="plus" />
          <span className="btn-label">{t('New folder')}</span>
        </Button>
      </div>
    </AdsSectionHeaderHolder>
  )
}

export default AdsSectionHeader
